<template>
<div>
  <div class="container container--narrow pdt-50 pdb-50">
    <div class="t-subtitle6 font-r  t-line-h-26 d-flex -align-items-center">
      {{ question.number }}. {{ question.contents.text }}
      <span class="t-color-mainBtn" v-if="question.essential">*</span>
    </div>
    <div class="mgt-16" v-if="question.contents && question.contents.image">
      <img :src="question.contents.image" alt="" class="b-radius4 survey-banner" />
    </div>
  <div class="mgt-24">
    <div 
      class="mgb-16 mdc-select mdc-select--outlined w-full mdc--select__custom mdc-select--no-label"
        data-mdc-auto-init="MDCSelect"  
        v-for="choice in question.choices" :key="choice.id">
    <div class="mdc-select__anchor h-46" aria-labelledby="outlined-select-label">
    <span class="mdc-notched-outline">
      <span class="mdc-notched-outline__leading"></span>
      <span class="mdc-notched-outline__notch" style="padding:0;">
        <span id="outlined-select-label"
          class="mdc-floating-label t-body6 t-color-textfieldGuid font-r" style="background:var(--DocumentWhite)!important;padding-right:5px;">
          {{ choice.contents }}
        </span>
      </span>
      <span class="mdc-notched-outline__trailing"></span>
    </span>
    <select
      class="mdc-select__native-control mdc-select--outlined w-full mgt-8 mgr-8"
      @change="setAnswer()"
      v-model="weight[choice.id]"
    >
      <option
        v-for="(rank, index) in baseRanks"
        :value="rank.value"
        v-if="
          !rank.selected ||
          rank.value === 0 ||
          weight[choice.id] === rank.value
        "
        :key="index"
      >
        {{ rank.text }}
      </option>
    </select>
  </div>
  </div>
  </div>
  </div>
  <div class="mgt-100"></div>
  </div>
</template>

<script>
/**
 * 설문 - 순위선택형 문항 컴포넌트(survey - select ranking question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCSelect } from "@material/select";

export default {
  props: ["question", "setedAnswer"],
  data() {
    return {
      baseRanks: {},
      totalViews: 0,
      weight: {},
    };
  },

  mounted() {
    this.initAnswer();
  },
  updated() {
    this.attachMertial();
  },

  methods: {
    attachMertial() {
      const selectElement = [].map.call(
        document.querySelectorAll(".mdc-select"),
        function (el) {
          let select = new MDCSelect.attachTo(el);
          return select;
        }
      );
    },
    // 답안 초기화(init answer)
    initAnswer() {
      this.weight = _.cloneDeep(this.setedAnswer.weight);
      //this.weight = { "132": 3, "133": 1, "134": 2 }
      this.totalViews = this.question.choices.length;

      this.baseRanks = _.map(_.range(this.totalViews), (value) => {
        return {
          value: this.totalViews - value,
          text: value + 1,
          selected: false,
        };
      });
      // console.log("this.baseRanks", this.baseRanks);
      this.baseRanks = this.createOptions(this.baseRanks);
      this.setAnswer();
    },

    //답안정보 설정 및 부모 컴포넌트에 전달(set answer / transfer parent component)
    setAnswer() {
      _.each(this.baseRanks, (baseRank) => {
        baseRank.selected = false;
      });

      _.each(this.weight, (weightVal, weightKey) => {
        _.each(this.baseRanks, (baseRank) => {
          if (baseRank.value === weightVal) {
            baseRank.selected = true;
          }
        });
      });

      let params = {
        questionId: this.question.id,
        text: "",
        comment: "",
        selected: [],
        weight: this.weight,
        isSolved: this.isSolved(),
      };
      this.$emit("setAnswers", params);
    },

    // select 기본 option data 생성(set basic select option data)
    createOptions(array) {
      // console.log("helkdsfjls", array);
      return [
        { value: 0, text: "", selected: false },
        { value: this.totalViews + 1, text: this.$t("3077"), selected: false },
      ].concat(array);
    },

    // 응답 여부 확인(check solved )
    isSolved() {
      let answerCheckCount = 0;
      let weightLength = 0;
      _.each(this.weight, (val, key) => {
        if (this.weight[key]) {
          answerCheckCount++;
        }
        weightLength++;
      });
      // console.log(weightLength,answerCheckCount)
      return weightLength === answerCheckCount ? true : false;
    },
  },
};
</script>
